import { show } from 'redux-modal'
import { SubmissionError } from 'redux-form'
import { getShoppingData, cleanShoppingData, setShoppingData } from 'actions/shoppingData'
import { getPageLocation } from 'selectors'
import {
  CODE_APPOINTMENT_AVAILABILITY_ERROR,
  CODE_QUICK_APPT_SUBMISSION_ERROR,
  DESC_PLEASE_SELECT_STORE,
  DESC_PLEASE_SELECT_VEHICLE
} from 'constant'
import { preparePhoneNumber } from 'helpers/phone-number'
import { isErrorCode, isErrorDescription } from 'helpers/utils'
import { rest, isApiError } from 'services'
import { googleAnalyticPurchase, googleAnalyticQuickApptSubmissionError } from 'actions/googleAnalytic'
import { setAppointmentResponse } from 'components/QuickAppointmentPage/actions'
import { APPOINMENT_SUBMISSION_ERROR_MODAL } from 'components/QuickAppointmentPage/Stepper/constants'
import { APPOINTMENT_SUCCESS_MODAL, APPOINTMENT_CHANGE_MODAL } from '../constants'
import { getAppointmentMethod, isQuickAppointment } from './helpers'

/* eslint-disable */
export const submitAppointment = ({
  phoneNumber,
  firstName,
  lastName,
  email,
  setCurrentStepIndex,
  from3Stepper,
  fromAppointmentStepper,
  setIsLoading,
  ...values
}) => (dispatch, getState) => {
  const location = getPageLocation(getState())
  const appointmentData = {
    ...values,
    firstName,
    lastName,
    email,
    ...preparePhoneNumber(phoneNumber),
    isFromOnlineAppointment: !!(fromAppointmentStepper || from3Stepper)
  }
  const profilePopulationData = { primaryPhone: phoneNumber, firstName, lastName, email }
  const appointmentMethod = getAppointmentMethod(location)
  const setApptContactDetails = !fromAppointmentStepper ? dispatch(getShoppingData(rest.api.changeAppointmentContactDetails, appointmentData)) :
    Promise.resolve()

  return setApptContactDetails
    .then(() => setIsLoading(true))
    .then(() => dispatch(getShoppingData(rest.api[appointmentMethod])))
    .then(data => {
      // send GTM statistic. Should be called before cleanShoppingData
      dispatch(googleAnalyticPurchase(isQuickAppointment(location) ? data : null))
      dispatch(cleanShoppingData())
      dispatch(setShoppingData({ totalCount: data.totalCount }))
      dispatch(setAppointmentResponse(data))
      if (!(fromAppointmentStepper || from3Stepper)) {
        setIsLoading(false)
        dispatch(show(APPOINTMENT_SUCCESS_MODAL, { profilePopulationData }))
      }
    })
    .catch(err => {
      if (isApiError(err)) {
        setIsLoading(false)
        if(isErrorCode({ err, code: CODE_APPOINTMENT_AVAILABILITY_ERROR })) {
          const { statusList = [] } = err
          const { description: message } = statusList.find(({ code }) =>
            code === CODE_APPOINTMENT_AVAILABILITY_ERROR)
          dispatch(show(APPOINTMENT_CHANGE_MODAL, { message }))
        } else if (isErrorCode({ err, code: CODE_QUICK_APPT_SUBMISSION_ERROR })) {
          dispatch(googleAnalyticQuickApptSubmissionError())
          dispatch(show(APPOINMENT_SUBMISSION_ERROR_MODAL, { setCurrentStepIndex }))
        } else if (isErrorDescription({ err, description: DESC_PLEASE_SELECT_VEHICLE })) {
          dispatch(show(APPOINMENT_SUBMISSION_ERROR_MODAL, { setCurrentStepIndex }))
        } else if (isErrorDescription({ err, description: DESC_PLEASE_SELECT_STORE })) {
          dispatch(show(APPOINMENT_SUBMISSION_ERROR_MODAL, { setCurrentStepIndex }))
        } else {
          throw new SubmissionError({ _error: err.status.description })
        }
      }
    })
}
